// extracted by mini-css-extract-plugin
export default {"title":"BTopCountryChart-module_title_e9c5a3c5"};